
import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { withTranslation } from "react-i18next";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import SaveButton from 'components/buttons/save';
import { API_URL } from "../../../helpers/app_url";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import ContactDetailMenu from '../menu/detail-menu'
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import TitleDropdowns from "components/dropdowns/Other/titleDropdowns"
import { getContactDetail } from "../../../store/actions";
import ContactData from '../forms/contact-data';
import classnames from "classnames"
import { map } from 'lodash';
import ActionDelete from 'components/buttons/actionDelete';
import Moment from 'react-moment';
import Swal from 'sweetalert2';
class ContactReferral extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
      referrals:[]
    };
    
  }
 
  componentDidMount() {
    const { match: { params }, onGetContactDetail } = this.props;
    if (params && params.id) {
      onGetContactDetail(params.contactid);
      this.fetchReferral();
    }
  }

  fetchReferral() {
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;

  axios.get(`${API_URL}Lead/allforcontact`, {
    headers: { Authorization: `Bearer ${token}` },
     params: {
                agentId: localStorage.getItem('userId'),
                contactId: this.props.match.params.id
        }
  })
  .then(response => {
    this.setState({
      referrals: response.data || [], 
      isLoading: false,
    });
  })
  .catch(error => {
    console.error('Error fetching data from second API:', error);
    this.setState({ isLoading: false });
  });
}


handleImpDateDelete = async (id) => {
  const confirmResult = await Swal.fire({
    title: 'Are you sure?',
    text: 'This action cannot be undone!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
  });

  if (confirmResult.isConfirmed) {
    try {
       const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;

      await axios.delete(`${API_URL}ContactImportantDate/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      this.setState(prevState => ({
        importantDates: prevState.importantDates.filter(item => item.id !== id)
      }));

      Swal.fire('Deleted!', 'The item has been deleted.', 'success');
    } catch (error) {
      console.error('Delete failed:', error);
      Swal.fire('Error', 'Failed to delete the item.', 'error');
    }
  }
};

  render() {
   
    const { contactDetail } = this.props;
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Contact Detail | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            <Row>
              <Col sm="3" className="pe-0">
                <ContactData contactDetail={contactDetail} />
              </Col>
              <Col sm="9" className="ps-0 pe-0">
                <Row className="project-header">
                  <Col sm='8'>
                    <Breadcrumbs
                      title="Contact"
                      breadcrumbItem="Contact Detail"
                    />

                  </Col>
                  <Col sm='4'>
                    <h2>{contactDetail.firstName + " " + contactDetail.lastName}</h2>
                  </Col>
                </Row>

                <ContactDetailMenu />
                <Card>
                   
                    <CardBody>
                         <h5 className="card-title">All Referrals</h5>
                          <Row>
                                <Col sm="12">
                                  
                                  <div className="table-responsive">
                                    <table className="table table-bordered border-primary">
                                      <thead className="">
                                        <tr>
                                          <th>#</th>
                                          <th>Date</th>
                                          <th>Name</th>
                                          <th>Email</th>
                                          <th>Mobile</th>
                                        
                                        </tr>
                                      </thead>
                                          <tbody>
                                          {map(this.state.referrals, (referral, datekey) => (
                                                        <tr key={"_note_" + datekey}>
                                                        <td>{datekey + 1 }</td>
                                                         <td> <Moment format='D MMM YYYY'>{referral.submittedDate	}</Moment></td>
                                                        <td> {referral.firstName + " "+ referral.lastName} </td>
                                                        <td> {referral.email} </td>
                                                           <td> {referral.mobile} </td>
                                                       
                                                        
                                                        
                                                        
                                                        </tr>
                                                      ))} 
                                          </tbody>
                                    </table>
                                  </div>
                                </Col>
                              </Row>
                    </CardBody>
                </Card>






              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>


    );
  }
}
ContactReferral.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  onGetContactDetail: PropTypes.object,
  contactDetail: PropTypes.object
}
const mapStateToProps = ({ contact }) =>
({
  contactDetail: contact.contactDetail,

});
const mapDispatchToProps = dispatch => ({
  onGetContactDetail: id => dispatch(getContactDetail(id)),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContactReferral)))